import Abstract from "./abstract";

export default class Entity extends Abstract {
  #nameElement;
  #fullNameElement;
  #innElement;
  #kppElement;
  #okpoElement;

  #name;
  #fullName;
  #inn;
  #kpp;
  #okpo;

  #fillableTextElements = this.item.querySelectorAll(`.js-fill-text`);
  #fillableBlockElement = this.item.querySelector(`.js-personal-fill-input`);
  #inputsElements = this.#fillableBlockElement.querySelectorAll(`input:not([name="organization-input"])`);
  #radioInputs = this.item.querySelectorAll(`.js-personal-radio`);

  #radioName = this.#radioInputs.length && this.#radioInputs[0].name;

  FillableTextElementType = {
    name: `name`,
    fullName: `fullName`,
    inn: `inn`,
    kpp: `kpp`,
    okpo: `okpo`,
  };

  textValue = {
    [this.FillableTextElementType.name]: (value) => value,
    [this.FillableTextElementType.fullName]: (value) => value,
    [this.FillableTextElementType.inn]: (value) => (value ? `ИНН: ${value}` : ``),
    [this.FillableTextElementType.kpp]: (value) => (value ? `КПП: ${value}` : ``),
    [this.FillableTextElementType.okpo]: (value) => (value ? `ОКПО: ${value}` : ``),
  };

  constructor(item) {
    super(item);

    this.#nameElement = this.item.querySelector(`[data-input-fill-name="${this.FillableTextElementType.name}"]`);
    this.#fullNameElement = this.item.querySelector(`[data-input-fill-name="${this.FillableTextElementType.fullName}"]`);
    this.#innElement = this.item.querySelector(`[data-input-fill-name="${this.FillableTextElementType.inn}"]`);
    this.#kppElement = this.item.querySelector(`[data-input-fill-name="${this.FillableTextElementType.kpp}"]`);
    this.#okpoElement = this.item.querySelector(`[data-input-fill-name="${this.FillableTextElementType.okpo}"]`);

    this.#name = this.#nameElement.value;
    this.#fullName = this.#fullNameElement.value;
    this.#inn = this.#innElement.value;
    this.#kpp = this.#kppElement.value;
    this.#okpo = this.#okpoElement.value;
  }

  #getValidateInputs() {
    const validate = [];
    this.#inputsElements.forEach((input) => {
      if (!input.classList.contains(`js-fill-kpp`) && input.value.length) {
        validate.push(input);
      }
    });
    return validate.length === 4;
  }

  getSubmitStatus() {
    return this.form[this.#radioName].value === `add` && this.#getValidateInputs();
  }

  getFillStatus() {
    return (
      this.#name !== this.#nameElement.value ||
      this.#fullName !== this.#fullNameElement.value ||
      this.#inn !== this.#innElement.value ||
      this.#kpp !== this.#kppElement.value ||
      this.#okpo !== this.#okpoElement.value
    );
  }

  submitForm(evt) {
    super.submitForm(evt);
  }

  fillTextElements() {
    super.fillTextElements();

    if (this.getFillStatus()) {
      this.#fillableTextElements.forEach((textElement) => {
        const type = textElement.dataset.fillType;
        const value = this.item.querySelector(`[data-input-fill-name="${type}"]`).value;
        textElement.textContent = this.textValue[type](value);
      });
    }
  }

  setAddressInputsFromRadio(radio) {
    super.setAddressInputsFromRadio(radio);
    Array.from(this.#fillableBlockElement.elements).forEach(
      (input) =>
        (input.value = input.name !== `organization-input` ? radio.dataset[this.FillableTextElementType[input.dataset.inputFillName]] : ``),
    );
  }
}
